import { render, staticRenderFns } from "./setores-de-atuacao.vue?vue&type=template&id=3bc1e404&"
import script from "./setores-de-atuacao.vue?vue&type=script&lang=ts&"
export * from "./setores-de-atuacao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports